import { render, staticRenderFns } from "./QuoteNotes.vue?vue&type=template&id=2c093d0b"
import script from "./QuoteNotes.vue?vue&type=script&lang=js"
export * from "./QuoteNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports